import dataAnalyseSimpleSignalService from "../shared/services/dataSimpleSignalService";
import analiseSignalService from "./../shared/services/analiseSignalService";

const REQUEST_ANALISE_SIGNAL = "REQUEST_ANALISE_SIGNAL";
const RESPONSE_ANALISE_SIGNAL = "RESPONSE_ANALISE_SIGNAL";
const REQUEST_ANALISE_SIGNAL_FAILURE = "REQUEST_ANALISE_SIGNAL_FAILURE";

const requestAnaliseSignalAction = () => {
  return {
    type: REQUEST_ANALISE_SIGNAL,
  };
};

const responseAnaliseSignalAction = (data) => {
  return {
    type: RESPONSE_ANALISE_SIGNAL,
    data,
  };
};

const requestAnaliseSignalActionFailure = (errors) => {
  return {
    type: REQUEST_ANALISE_SIGNAL_FAILURE,
    errors,
  };
};

const getAnaliseSignal = (options) => {
  return (dispatch) => {
    dispatch(requestAnaliseSignalAction());

    analiseSignalService
      .get(options)
      .then((result) => {
        dispatch(responseAnaliseSignalAction(result.data));
      })
      .catch((error) => {
        dispatch(requestAnaliseSignalActionFailure(error.response));
      });
  };
};

const REQUEST_ANALISE_SIMPLE_SIGNAL = "REQUEST_ANALISE_SIMPLE_SIGNAL";
const RESPONSE_ANALISE_SIMPLE_SIGNAL = "RESPONSE_ANALISE_SIMPLE_SIGNAL";
const REQUEST_ANALISE_SIGNAL_SIMPLE_FAILURE = "REQUEST_ANALISE_SIGNAL_SIMPLE_FAILURE";

const requestAnaliseSimpleSignalAction = () => {
  return {
    type: REQUEST_ANALISE_SIMPLE_SIGNAL,
  };
};

const responseAnaliseSimpleSignalAction = (data) => {
  return {
    type: RESPONSE_ANALISE_SIMPLE_SIGNAL,
    data,
  };
};

const requestAnaliseSimpleSignalActionFailure = (errors) => {
  return {
    type: REQUEST_ANALISE_SIGNAL_SIMPLE_FAILURE,
    errors,
  };
};

const getAnaliseSimpleSignals = (options) => {
  return (dispatch) => {
    dispatch(requestAnaliseSimpleSignalAction());

    analiseSignalService
      .getSimpleSignals({ id: options.currentDevice.id, startDate: options.startDate, endDate: options.endDate })
      .then((result) => {
        const data = dataAnalyseSimpleSignalService(result.data, options.currentDevice.type);
        dispatch(responseAnaliseSimpleSignalAction(data));
      })
      .catch((error) => {
        dispatch(requestAnaliseSimpleSignalActionFailure(error.response));
      });
  };
};

export {
  REQUEST_ANALISE_SIGNAL,
  RESPONSE_ANALISE_SIGNAL,
  REQUEST_ANALISE_SIGNAL_FAILURE,
  getAnaliseSignal,
  REQUEST_ANALISE_SIMPLE_SIGNAL,
  RESPONSE_ANALISE_SIMPLE_SIGNAL,
  REQUEST_ANALISE_SIGNAL_SIMPLE_FAILURE,
  getAnaliseSimpleSignals,
};
